import React from "react";

import { Stack } from "@mui/material";
import { InsightsBreadcrumb } from "components/Deal-insights/InsightsBreadcrumb";
import { LookThrough } from "pages/Look-through/LookThrough";

export const LookThroughFull: React.FC = () => {
  return (
    <Stack sx={{ p: "16px", gap: "16px", flexGrow: 1, overflow: "hidden", backgroundColor: "#f6f8fc" }}>
      <InsightsBreadcrumb current="Look Through" title="Look Through" />

      {/* Only this content area scrolls; the breadcrumb header stays fixed. */}
      <Stack sx={{ flexGrow: 1, minHeight: 0, overflowY: "auto" }}>
        <LookThrough />
      </Stack>
    </Stack>
  );
};
